'use client'
import { FC, ReactNode, useEffect } from 'react'
type WordPressAgenturLayoutProps = {
  children: ReactNode
}
const WordPressAgenturLayout: FC<WordPressAgenturLayoutProps> = ({ children }) => {
  useEffect(() => {
    document.body.setAttribute('data-theme', 'KMRS-WordPress')

    return () => {
      document.body.removeAttribute('data-theme')
    }
  }, [])
  return children
}

export default WordPressAgenturLayout
